import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Navbar.css";
import logo from "../assets/logo.png";

import {
  FaHome,
  FaInfoCircle,
  FaChalkboardTeacher,
  FaUserPlus,
  FaUniversity,
  FaCalendarAlt,
  FaPhoneAlt,
  FaBars,
  FaTimes,
  FaTree   // 🌳 NEW ICON
} from "react-icons/fa";

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  const handleClose = () => setMenuOpen(false);

  return (
    <>
      <nav className="navbar">

        {/* LOGO */}
        <Link to="/" className="logo-container">
          <img src={logo} alt="Lotus Lap Logo" />
        </Link>

        {/* HAMBURGER */}
        <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? <FaTimes /> : <FaBars />}
        </div>

        {/* MENU */}
        <ul className={`nav-links ${menuOpen ? "active" : ""}`}>

          <li>
            <Link to="/" onClick={handleClose}
              className={location.pathname === "/" ? "active" : ""}>
              <FaHome /><span>Home</span>
            </Link>
          </li>

          <li>
            <Link to="/about" onClick={handleClose}
              className={location.pathname === "/about" ? "active" : ""}>
              <FaInfoCircle /><span>About</span>
            </Link>
          </li>

          <li>
            <Link to="/academics" onClick={handleClose}
              className={location.pathname === "/academics" ? "active" : ""}>
              <FaChalkboardTeacher /><span>Academics</span>
            </Link>
          </li>

          <li>
            <Link to="/admission" onClick={handleClose}
              className={location.pathname === "/admission" ? "active" : ""}>
              <FaUserPlus /><span>Admission</span>
            </Link>
          </li>

          <li>
            <Link to="/infrastructure" onClick={handleClose}
              className={location.pathname === "/infrastructure" ? "active" : ""}>
              <FaUniversity /><span>Infrastructure</span>
            </Link>
          </li>

          {/* 🌳 NEW AMRUTHAVANAM PAGE */}
          <li>
            <Link to="/amruthavanam" onClick={handleClose}
              className={location.pathname === "/amruthavanam" ? "active" : ""}>
              <FaTree /><span>Amruthavanam</span>
            </Link>
          </li>

          <li>
            <Link to="/events" onClick={handleClose}
              className={location.pathname === "/events" ? "active" : ""}>
              <FaCalendarAlt /><span>Events</span>
            </Link>
          </li>

          <li>
            <Link to="/contact" onClick={handleClose}
              className={location.pathname === "/contact" ? "active" : ""}>
              <FaPhoneAlt /><span>Contact</span>
            </Link>
          </li>

        </ul>
      </nav>

      {/* OVERLAY */}
      {menuOpen && <div className="overlay" onClick={handleClose}></div>}
    </>
  );
}

export default Navbar;